import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../../base-modal/base-modal.component";
import {FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {BloggerModalService} from "../services/blogger-modal.service";
import {
  deleteProfileBloggerModalName,
  deleteProfilesBloggerFormFields
} from "../configs/delete-profile-blogger-modal-config";
import {DeleteProfileBloggerDialogData} from "../types/delete-profile-blogger-modal.types";
import {MatOption} from "@angular/material/core";
import {MatSelect} from "@angular/material/select";
import {RecordData} from "../../../../types/records-table.types";

@Component({
  selector: 'app-delete-profile-blogger-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    FormsModule,
    MatButton,
    MatFormField,
    MatLabel,
    ReactiveFormsModule,
    MatOption,
    MatSelect
  ],
  templateUrl: './delete-profile-blogger-modal.component.html',
  styleUrl: './delete-profile-blogger-modal.component.scss'
})
export class DeleteProfileBloggerModalComponent extends BaseModalComponent {
  private dialogData = inject<DeleteProfileBloggerDialogData>(MAT_DIALOG_DATA);
  private bloggerModalService: BloggerModalService = inject(BloggerModalService);

  public readonly deleteProfilesBloggerFormFields = deleteProfilesBloggerFormFields;
  public formGroup: FormGroup = new FormGroup({});
  public profiles: Array<RecordData> = [];

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(deleteProfileBloggerModalName);
    this.initForm();
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(deleteProfileBloggerModalName);
  }

  public isValid(): boolean {
    return !!this.formGroup.get('url' as string)?.value;
  }

  public async handleProfileBloggerDelete(): Promise<void> {
    await this.bloggerModalService.deleteProfileBlogger(this.formGroup.get('url' as string)?.value);
    this.closeDialog('cancel');
  }

  private initForm(): void {
    const fieldNames: Array<string> = this.deleteProfilesBloggerFormFields.map(field => field.fieldName);
    this.formGroup = this.baseModalService.initForm(fieldNames);
    this.profiles = this.dialogData.recordData['profiles'] as Array<RecordData>;
  }
}
